const HEX_SHORTHAND_LENGTH = 3
const HEX_FULL_LENGTH = 6

/**
 * Normalise a CSS hex colour to 6 digits. Vuetify hands back the SCSS value
 * verbatim, so theme colours arrive as shorthand ("#fff"), while Capacitor's
 * toolbarColor expects a full hex string.
 *
 * @returns {string|null} lowercase "#rrggbb", or null if not a hex colour.
 */
export function expandHexColor(hex) {
  const raw = typeof hex === 'string' ? hex.trim().toLowerCase() : ''
  if (!raw.startsWith('#')) return null

  const digits = raw.slice(1)
  if (!/^[0-9a-f]+$/.test(digits)) return null

  if (digits.length === HEX_FULL_LENGTH) return `#${digits}`
  if (digits.length === HEX_SHORTHAND_LENGTH) {
    return `#${digits.split('').map(d => d + d).join('')}`
  }
  return null
}
